<div class="preloader-backdrop" *ngIf="isSpinnerVisible">
  <div class="page-preloader"></div>
</div>